import PropTypes from 'prop-types';
import './aceCore';
import 'ace-builds/webpack-resolver';
import 'ace-builds/src-min-noconflict/ext-language_tools';
import 'ace-builds/src-min-noconflict/mode-json';
import 'ace-builds/src-min-noconflict/theme-github';
import 'ace-builds/src-min-noconflict/ext-static_highlight';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/ext-language_tools';
// Habilita el cuadro de búsqueda nativo de Ace (Ctrl+F / Ctrl+H). El comando
// `find` hace require de 'ace/ext/searchbox' en runtime; con Vite hay que
// importarlo estático para que quede en el bundle, si no Ctrl+F no hace nada.
import 'ace-builds/src-noconflict/ext-searchbox';
import AceEditor from 'react-ace';

export const modes = {
  JS: 'javascript',
  JAVA: 'java',
  PY: 'python',
  XML: 'xml',
  RUBY: 'ruby',
  SASS: 'sass',
  MD: 'markdown',
  MYSQL: 'mysql',
  JSON: 'json',
  HTML: 'html',
  HANDLEBARS: 'handlebars',
  GO: 'golang',
  CSHARP: 'csharp',
  COFFE: 'coffee',
  CSS: 'css',
};

export const themes = {
  MONOKAI: 'monokai',
  GITHUB: 'github',
  TOMORROW: 'tomorrow',
  KUROIR: 'kuroir',
  TWILIGHT: 'twilight',
  XCODE: 'xcode',
  TEXTMATE: 'textmate',
  SOLARIZED_DARK: 'solarized dark',
  SOLARIZED_LIGHT: 'solarized light',
  TERMINAL: 'terminal',
};

const AceEditorInput = ({
  disabled = false, fontSize = 14, height = '200px',
  invalid = false, mode = modes.JSON, name = '',
  onChangeContent = () => null, onLoad = () => null, onValidate = () => null,
  placeholder = '', theme = themes.GITHUB, value = null,
  width = '100%',
}) => {
  const buildOnChangeEvent = (currentValue) => {
    const event = {
      target: {
        value: currentValue,
        name,
      },
    };
    onChangeContent(event);
  };

  const customStyle = {
    border: 'thin solid #E9E9E9',
    borderRadius: '5px',
    borderLeft: invalid ? '3px solid #DB5461' : null,
    boxSizing: 'border-box',
    transition: invalid ? 'border-left-width .3s ease-out' : null,
  };

  return (
    <AceEditor
      style={customStyle}
      fontSize={fontSize}
      height={height}
      highlightActiveLine
      mode={mode}
      name={name}
      onChange={buildOnChangeEvent}
      placeholder={placeholder}
      showPrintMargin={false}
      showGutter
      theme={theme}
      value={value}
      width={width}
      wrapEnabled
      setOptions={{
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: true,
        hScrollBarAlwaysVisible: false,
        showLineNumbers: true,
        tabSize: 2,
        vScrollBarAlwaysVisible: false,
        useWorker: false,
      }}
      readOnly={disabled}
      onLoad={onLoad}
      onValidate={onValidate}
    />
  );
};

AceEditorInput.propTypes = {
  disabled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  height: PropTypes.string,
  invalid: PropTypes.bool,
  mode: PropTypes.string,
  name: PropTypes.string,
  onChangeContent: PropTypes.func,
  onLoad: PropTypes.func,
  onValidate: PropTypes.func,
  placeholder: PropTypes.string,
  theme: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  width: PropTypes.string,
};

export default AceEditorInput;
